export default "__VITE_ASSET__89ff2708__"